export default __webpack_public_path__ + "static/media/send-email.a8afcd72.svg";